import { fetcher, noRevalidateOnlyStaleOptions } from 'src/utils/axios';
import { ENDPOINTS } from './endpoints';
import { useMemo } from 'react';
import useSWR from 'swr';
import { filterSettingsMenuByRole } from 'src/sections/settings/settings_menu';
import { useGetMe } from './user_api';

export function useGetSettingMenu() {
  const URL = ENDPOINTS.menu.get_setting_menu;
  const { data, isLoading, error, isValidating } = useSWR(
    URL,
    fetcher,
    noRevalidateOnlyStaleOptions,
  );
  const { isAdmin, searchLoading: meLoading } = useGetMe();
  const memoizedValue = useMemo(
    () => ({
      isSettingAccess: data?.result?.isSettingAccess ?? false,
      searchResults: filterSettingsMenuByRole(data?.result?.menus || [], isAdmin),
      searchLoading: isLoading || meLoading,
      searchError: error,
      searchValidating: isValidating,
    }),
    [data?.result, error, isLoading, isValidating, isAdmin, meLoading],
  );
  return memoizedValue;
}

export function useGetRoleMenu() {
  const URL = ENDPOINTS.menu.get_role_menu;
  const { data, isLoading, error, isValidating } = useSWR(
    URL,
    fetcher,
    noRevalidateOnlyStaleOptions,
  );
  const memoizedValue = useMemo(
    () => ({
      searchResults: data?.result || [],
      searchLoading: isLoading,
      searchError: error,
      searchValidating: isValidating,
    }),
    [data?.result, error, isLoading, isValidating],
  );
  return memoizedValue;
}
